import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 16,
		cy: 16,
		r: 12,
		stroke: "currentColor",
		strokeWidth: 2.4,
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.0003 22.3333C16.2838 22.3333 16.5212 22.2375 16.7127 22.0458C16.9041 21.8542 16.9999 21.6167 16.9999 21.3333V15.6666C16.9999 15.3833 16.904 15.1458 16.7123 14.9542C16.5205 14.7625 16.2829 14.6667 15.9995 14.6667C15.716 14.6667 15.4785 14.7625 15.2871 14.9542C15.0956 15.1458 14.9999 15.3833 14.9999 15.6666V21.3333C14.9999 21.6167 15.0958 21.8542 15.2875 22.0458C15.4793 22.2375 15.7169 22.3333 16.0003 22.3333ZM15.9999 12.3846C16.305 12.3846 16.5608 12.2814 16.7672 12.075C16.9736 11.8686 17.0768 11.6129 17.0768 11.3077C17.0768 11.0026 16.9736 10.7469 16.7672 10.5404C16.5608 10.334 16.305 10.2308 15.9999 10.2308C15.6948 10.2308 15.439 10.334 15.2326 10.5404C15.0262 10.7469 14.923 11.0026 14.923 11.3077C14.923 11.6129 15.0262 11.8686 15.2326 12.075C15.439 12.2814 15.6948 12.3846 15.9999 12.3846Z",
		fill: "currentColor"
	})]
});
export { SvgInfo as ReactComponent };
